// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1Lkv5","btnBoleto":"Button_btnBoleto__2bU6F","outlined":"Button_outlined__3Uswj"};